import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { LoginCredentials } from "@domain/models/User";
import { authentication } from "@services/auth/AuthService";
import { authKeys } from "../authKeys";
export const useLoginMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: currentUser => {
        if (currentUser) {
          queryClient.setQueryData(authKeys.currentUser(), currentUser);
          return;
        }
        queryClient.invalidateQueries({
          queryKey: authKeys.currentUser()
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
function _temp(credentials) {
  return authentication.login(credentials);
}